type TabsType = {
  [key: string]: string[];
};

const getActiveTab = ({ pathname }: { pathname: string }) => {
  const tabs: TabsType = {
    'administrim-konkurrim': ['/administrim-konkurrim'],
    'administrim-formimiFillestar': ['/administrim-formimiFillestar'],
    'administrim-formimiVazhdues': ['/administrim-formimiVazhdues'],
    faza1: ['/faza-aktive'],
    konkurrime: ['/konkurrime'],
    rezultateFaza: ['/rezultate-faza'],
    trajnime: ['/trajnime'],
    'program-tematik': ['/program-tematik'],
    'propozo-trajnim': ['/propozo-trajnim'],
    kalendari: ['/kalendari'],
    'roli-trajnues': ['/roli-trajnues'],
    'listeprezenca-per-pjesemarres': ['/listeprezenca-per-pjesemarres'],
    ndryshoFjalekalimin: ['/ndryshoFjalekalimin'],
    modules: ['/modules'],
    propozime: ['/propozime'],
    'trajnime-program-tematik': ['/trajnime-program-tematik'],
    'trajnime-kalendari': ['/trajnime-kalendari'],
    'liste-prezenca/:id': ['/liste-prezenca/:id'],
    'liste-prezenca-trajnimet': ['/liste-prezenca-trajnimet'],
  };

  for (const key in tabs) {
    if (pathname.includes(key)) {
      return tabs[key];
    }
  }
  return ['/'];
};

export default getActiveTab;
